<template>
	<b-modal v-model="vmodel" no-close-on-backdrop no-close-on-esc size="xl" title="Editor de imagenes" @ok="crop" @cancel="resetInput" @close="resetInput">
		<b-row>
			<b-col class="d-flex justify-content-center text-cente">
				<img id="image" :src="src" alt="Picture" crossorigin />
			</b-col>
		</b-row>
	</b-modal>
</template>

<script>
import Cropper from "cropperjs";
export default {
	props: {
		src: String,
		value: Boolean,
		aspectRatio: {
			type: Number
			// Ejemplos mas comunes
			// 16/9 - 4/3 - 1/1 - 2/3
		}
	},
	data: () => ({
		cropperInstance: null
	}),
	computed: {
		vmodel: {
			get() {
				return this.value;
			},
			set(v) {
				this.$emit("input", v);
			}
		}
	},
	watch: {
		src() {
			this.initCropper();
		}
	},
	mounted() {
		if (this.src) {
			this.initCropper();
		}
	},
	methods: {
		initCropper() {
			setTimeout(() => {
				var image = document.querySelector("#image");
				this.cropperInstance = new Cropper(image, {
					dragMode: "move",
					aspectRatio: this.aspectRatio,
					autoCropArea: 0.65,
					restore: false,
					guides: false,
					center: false,
					highlight: false,
					cropBoxMovable: false,
					cropBoxResizable: false,
					toggleDragModeOnDblclick: false,
					viewMode: 1
				});
			}, 300);
		},
		resetInput() {
			this.$emit('crop',null);
		},
		crop() {
			const croppedImg = this.cropperInstance
				.getCroppedCanvas({
					width: 960
				})
				.toDataURL("image/jpeg", 0.7);
			const b64File = this.convertFile(croppedImg);
			const blobFile = this.b64toBlob(b64File.data, b64File.contentType);
			let file = new File([blobFile], "img.png",{type: "image/png", lastModified:new Date().getTime()});
			this.$emit("crop",file);
		},
		convertFile(file) {
			const block = file.split(";");
			const contentType = block[0].split(":")[1];
			const data = block[1].split(",")[1];
			return { contentType, data };
		},
		b64toBlob(b64Data, contentType, sliceSize) {
			contentType = contentType || "";
			sliceSize = sliceSize || 512;

			var byteCharacters = atob(b64Data);
			var byteArrays = [];

			for (
				var offset = 0;
				offset < byteCharacters.length;
				offset += sliceSize
			) {
				var slice = byteCharacters.slice(offset, offset + sliceSize);

				var byteNumbers = new Array(slice.length);
				for (var i = 0; i < slice.length; i++) {
					byteNumbers[i] = slice.charCodeAt(i);
				}

				var byteArray = new Uint8Array(byteNumbers);

				byteArrays.push(byteArray);
			}

			var blob = new Blob(byteArrays, { type: contentType });
			return blob;
		}
	}
};
</script>

<style scoped>
@import "~cropperjs/src/css/cropper.css";

img {
	max-width: 100%;
}
</style>
